import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { purchaseNotices } from '../data/content';
export function PurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const show = window.setTimeout(() => setVisible(true), 6000);
    return () => window.clearTimeout(show);
  }, [dismissed]);
  useEffect(() => {
    if (!visible || dismissed) return;
    const hide = window.setTimeout(() => setVisible(false), 7000);
    const next = window.setTimeout(() => {
      setIndex(current => (current + 1) % purchaseNotices.length);
      setVisible(true);
    }, 22000);
    return () => {
      window.clearTimeout(hide);
      window.clearTimeout(next);
    };
  }, [visible, index, dismissed]);
  const notice = purchaseNotices[index];
  return <div className="pointer-events-none fixed bottom-4 left-4 z-40 max-w-[calc(100vw-2rem)]" aria-live="polite" data-id="element-154" data-mp="b66e7rtjxj9y">
      <AnimatePresence data-id="element-155" data-mp="1z5c7drbp0ol2">
        {visible && !dismissed && <motion.aside initial={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} transition={{
        duration: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-[19rem] max-w-full items-start gap-3 rounded-2xl bg-white p-4 shadow-lg ring-1 ring-blue-100" data-id="element-156" data-mp="1z3re05147bos">
            <div className="min-w-0 flex-1" data-id="element-157" data-mp="1ff8tw1uyuogy">
              <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[0.14em] text-emerald-600" data-id="element-158" data-mp="1kgfzbu9mzbkg">
                <span className="h-2 w-2 rounded-full bg-emerald-500" aria-hidden="true" data-id="element-159" data-mp="1p8zid6r3eywn" />
                Compra verificada
              </p>
              <p className="mt-2 text-sm font-bold text-slate-900" data-id="element-160" data-mp="wqu4fj0arii9">
                {notice.name} de {notice.city}
              </p>
              <p className="truncate text-sm text-slate-600" data-id="element-161" data-mp="200zkw9kc7qos">
                Compró <span className="font-semibold text-blue-700" data-id="element-162" data-mp="1v36crazh4mlv">{notice.product}</span>
              </p>
              <p className="mt-1 text-xs text-slate-500" data-id="element-163" data-mp="28u330v5xgrpr">hace 2 minutos</p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar aviso" className="rounded-md p-1 text-slate-400 transition-colors duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:bg-blue-50 hover:text-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-300" data-id="element-164" data-mp="24szr2jr03ftt">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-165" data-mp="1l4qmtbc6njdy" />
            </button>
          </motion.aside>}
      </AnimatePresence>
    </div>;
}